import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { IAttributes } from 'src/app/models/IAttributes';
import { IPatientDetails } from 'src/app/models/IEPrescriptionXMLDTO';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { IMessage } from 'src/app/models/IMedicationHistoryDTO';
import { MessageInbox } from 'src/app/models/IMessaging';
import { IPatientPortaInformation } from 'src/app/models/IPatientPortaInformation';
import { PersonalInfoService } from 'src/app/Services/Demographics/personal-info.service';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { RxService } from 'src/app/Services/NewVisitNote/rx.service';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { SharedService } from 'src/app/Sharedservice/SharedService';

@Component({
  selector: 'app-PPdemographics',
  templateUrl: './patient-request-information.component.html',
  styleUrls: ['./patient-request-information.component.css']
})
export class PatientRequestInformationComponent implements OnInit {

  PatientRequestInformationForm: FormGroup;
  public linkID: number = 0;

  constructor(private formBuilder: FormBuilder, private toastr: ToastrService,
    private messageService: MessagesService, private router: Router,
    private route: ActivatedRoute, private rxService: RxService,
    private sharedService: SharedService, public dialog: MatDialog
    , private personalService: PersonalInfoService, private _datePipe: DatePipe,
    private schedulerservice: SchedularServiceService, private spinner: NgxSpinnerService
  ) {
    this.linkID = Number(this.route.snapshot.paramMap.get('linkId'));
  }

  ngOnInit() {
    this.spinner.show();
    ;
    this.PatientRequestInformationForm = this.formBuilder.group({
      rejectNotes: ['', Validators.required],
      rejectReason: [''],

    })
    this.personalDropDownsBinding();
    // setTimeout(() => {
    //   this.getPatientRequestDetails(this.linkID);
    // }, 1000);

  }
  lstPatientRequestInformation: IPatientPortaInformation;

  PatientLastName: string = '';
  PatientMiddleName: string = ''; PatientFirstName: string = '';
  Dob: string = ''; Gender: string = '';
  MaritalStatus: string = ''; Race: string = '';
  Ethnicity: string = ''; Language: string = ''; MaidenName: string = ''; Locations: string = '';
  public ContactAddressLine1: string = "";
  public ContactAddressLine2: string = "";
  public ContactZipCode: string = "";
  public ContactZipCodeExt: string = "";
  public ContactCity: string = "";
  public ContactState: string = "";
  public ContactHomePhone: string = "";
  public ContactCellPhone: string = "";
  public ContactWorkPhone: string = "";
  public PreferredContactMethod: string = "";
  public PrimaryEmail: string = "";
  public SecondaryEmail: string = "";
  public Notes: string = "";
  public EmergencyContactType: string = "";
  public EmergencyContactLName: string = "";
  public EmergencyContactFName: string = "";
  public EmergencyContactMName: string = "";
  public EmergencyContactRelation: string = "";
  public EmergencyContactPhone: string = "";
  public EmergencyContactAddress: string = "";
  public EmergencyContactZipCode: string = "";
  public EmergencyContactZipCodeExt: string = "";
  public EmergencyContactCity: string = "";
  public EmergencyContactState: string = "";
  public EmergencyContactEmail: string = "";
  isDisableRejectReason: boolean = false;
  requestStatus: string = '';
  isVisableRejectreason: boolean = false;
  isVisableRejectedBy: boolean = false;
  isDisableDemographicsbutton: boolean = false;
  rejectedBy: string = '';
  rejectedDate: string = '';

  maxChars = 230;
  charCount = '';
  isPatientStatus: boolean = false;
  patientId: number = 0;
  hideRejectbutton: boolean = true;
  hideRejectReason: boolean = true;
  rejectNotes: string = '';
  contactType: string = '';
  public lstattrbutes: IAttributes[];
  public lstGender: IAttributes[];
  public lstPreferredContactMethod: IAttributes[];
  public lstcontacttype: IAttributes[];
  public lstEthinicity: IAttributes[];
  public lstMaritalStatus: IAttributes[];
  public lstRace: IAttributes[];
  public lstLanguage: IAttributes[];
  public lstLocations: ILocationDetails[];
  public lstrelations: IAttributes[];

  personalDropDownsBinding() {
    ;
    this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data;
      this.lstLocations = this.lstLocations.filter(a => a.active == true)
    });
    this.sharedService.getAttributes().subscribe(data => {
      this.lstattrbutes = data;
      this.lstGender = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '11');
      this.lstMaritalStatus = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '13');
      this.lstRace = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '16');
      this.lstEthinicity = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '24');
      this.lstPreferredContactMethod = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '58');
      this.lstLanguage = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '26');
      this.lstcontacttype = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '9');
      this.lstrelations = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '19');
      this.getPatientRequestDetails(this.linkID);
    });
    //this.getPatientRequestDetails(this.linkID);

  }
  getPatientRequestDetails(id: number) {
    ;
    this.spinner.show();
    this.personalService.getPatientRequestInformationById(id)
      .subscribe(
        (dataRef: any) => {
          ;
          this.lstPatientRequestInformation = dataRef;
          this.PatientLastName = this.lstPatientRequestInformation.LastName;
          this.PatientMiddleName = this.lstPatientRequestInformation.MiddleName;
          this.PatientFirstName = this.lstPatientRequestInformation.FirstName;
          this.MaidenName = this.lstPatientRequestInformation.MaidenName;
          this.ContactAddressLine1 = this.lstPatientRequestInformation.AddressLine1;
          this.ContactAddressLine2 = this.lstPatientRequestInformation.AddressLine2;
          this.ContactZipCode = this.lstPatientRequestInformation.ZIP;
          this.ContactZipCodeExt = this.lstPatientRequestInformation.Extension;
          this.ContactCity = this.lstPatientRequestInformation.City;
          this.ContactState = this.lstPatientRequestInformation.State;
          this.ContactHomePhone = this.lstPatientRequestInformation.HomePhone;
          this.ContactWorkPhone = this.lstPatientRequestInformation.WorkPhone;
          this.ContactCellPhone = this.lstPatientRequestInformation.CellPhone;
          this.PrimaryEmail = this.lstPatientRequestInformation.PrimaryEmail;
          this.SecondaryEmail = this.lstPatientRequestInformation.SecondaryEmail;
          this.Notes = this.lstPatientRequestInformation.ContactNotes;
          this.requestStatus = this.lstPatientRequestInformation.status;
          var emergencyContactRelation = 0;
          //********* Primary Contact Info****/
          if (this.lstPatientRequestInformation.PrimContactType != '0') {
            if (this.lstPatientRequestInformation.PrimContactType == '56') {
              this.EmergencyContactLName = this.lstPatientRequestInformation.PrimLastName;
              this.EmergencyContactFName = this.lstPatientRequestInformation.PrimFirstName;
              this.EmergencyContactMName = this.lstPatientRequestInformation.PrimMiddleName;
              this.EmergencyContactPhone = this.lstPatientRequestInformation.PrimContactPhone;
              this.EmergencyContactAddress = this.lstPatientRequestInformation.PrimAddress;
              this.EmergencyContactZipCode = this.lstPatientRequestInformation.PrimZip;
              this.EmergencyContactZipCodeExt = this.lstPatientRequestInformation.PrimExtension;
              this.EmergencyContactCity = this.lstPatientRequestInformation.PrimCity;
              this.EmergencyContactState = this.lstPatientRequestInformation.PrimState;
              this.EmergencyContactEmail = this.lstPatientRequestInformation.PrimaryEmergencyContactEmail;
              this.contactType = this.lstPatientRequestInformation.PrimContactType;
              emergencyContactRelation = this.lstPatientRequestInformation.PrimRelationShip;
            }
          }
          //********* Secondary*/
          if (this.lstPatientRequestInformation.SecContactType != '0') {
            if (this.lstPatientRequestInformation.SecContactType == '53') {
              this.EmergencyContactLName = this.lstPatientRequestInformation.SecLastName;
              this.EmergencyContactFName = this.lstPatientRequestInformation.SecFirstName;
              this.EmergencyContactMName = this.lstPatientRequestInformation.SecMiddleName;
              this.EmergencyContactPhone = this.lstPatientRequestInformation.SecContactPhone;
              this.EmergencyContactAddress = this.lstPatientRequestInformation.SecAddress;
              this.EmergencyContactZipCode = this.lstPatientRequestInformation.SecZip;
              this.EmergencyContactZipCodeExt = this.lstPatientRequestInformation.SecExtension;
              this.EmergencyContactCity = this.lstPatientRequestInformation.SecCity;
              this.EmergencyContactState = this.lstPatientRequestInformation.SecState;
              this.EmergencyContactEmail = this.lstPatientRequestInformation.SecondaryEmergencyContactEmail;
              this.contactType = this.lstPatientRequestInformation.SecContactType;
              emergencyContactRelation = Number(this.lstPatientRequestInformation.SecRelationShip);
            }
          }

          //********* Tertiary Contact Type */
          if (this.lstPatientRequestInformation.TertiaryContactType != '0') {
            if (this.lstPatientRequestInformation.TertiaryContactType == '29') {
              this.EmergencyContactLName = this.lstPatientRequestInformation.TertiaryLastName;
              this.EmergencyContactFName = this.lstPatientRequestInformation.TertiaryFirstName;
              this.EmergencyContactMName = this.lstPatientRequestInformation.TertiaryMiddleName;
              this.EmergencyContactPhone = this.lstPatientRequestInformation.TertiaryContactPhone;
              this.EmergencyContactAddress = this.lstPatientRequestInformation.TertiaryAddress;
              this.EmergencyContactZipCode = this.lstPatientRequestInformation.TertiaryZip;
              this.EmergencyContactZipCodeExt = this.lstPatientRequestInformation.TertiaryExtension;
              this.EmergencyContactCity = this.lstPatientRequestInformation.TertiaryCity;
              this.EmergencyContactState = this.lstPatientRequestInformation.TertiaryState;
              this.EmergencyContactEmail = this.lstPatientRequestInformation.TertiaryEmergencyContactEmail;
              this.contactType = this.lstPatientRequestInformation.TertiaryContactType;
              emergencyContactRelation = this.lstPatientRequestInformation.TertiaryRelationShip;
            }
          }

          ;
          if (this.lstPatientRequestInformation.status === 'Completed') {
            this.hideRejectbutton = false;
            this.hideRejectReason = false;
            this.isPatientStatus = true;
            this.patientId = Number(this.lstPatientRequestInformation.PatientId);
            this.PatientRequestInformationForm.patchValue({
              rejectReason: false
            })
          } else {
            this.hideRejectbutton = true;
            this.hideRejectReason = true;
          }
          if (this.lstPatientRequestInformation.comments == null || this.lstPatientRequestInformation.comments == "") {
            this.isDisableRejectReason = false;
          } else {
            this.hideRejectbutton = false;
            this.hideRejectReason = true;
            this.PatientRequestInformationForm.patchValue({
              rejectNotes: this.lstPatientRequestInformation.comments,
              rejectReason: true
            })
            this.rejectNotes = this.lstPatientRequestInformation.comments;
            this.isVisableRejectedBy = true;
            this.charCount = this.lstPatientRequestInformation.comments;
            this.rejectedBy = this.lstPatientRequestInformation.createdBy + ' ' + this.lstPatientRequestInformation.rejectedOn;
            this.rejectedDate = this.lstPatientRequestInformation.rejectedOn;
            this.isVisableRejectreason = true;
            this.isDisableRejectReason = true;
            this.isDisableDemographicsbutton = true;

          }
          if (this.lstPatientRequestInformation.Dob != null || this.lstPatientRequestInformation.Dob != undefined || this.lstPatientRequestInformation.Dob != null) {
            this.Dob = this._datePipe.transform(this.lstPatientRequestInformation.Dob, 'MM/dd/yyyy');
          } if (this.lstRace.length > 0 && this.lstRace != undefined) {
            var racelst = this.lstRace.filter(x => x.attributeId === this.lstPatientRequestInformation.Race.toString())
            if (racelst.length > 0)
              this.Race = racelst[0].attributeName;
          } if (this.lstEthinicity.length > 0) {
            var ethnicitylst = this.lstEthinicity.filter(x => x.attributeId === this.lstPatientRequestInformation.Ethnicity.toString());
            if (ethnicitylst.length > 0)
              this.Ethnicity = ethnicitylst[0].attributeName;
          } if (this.lstMaritalStatus.length > 0) {
            var maritalStatuslst = this.lstMaritalStatus.filter(x => x.attributeId === this.lstPatientRequestInformation.MaritalStatus.toString())
            if (maritalStatuslst.length > 0)
              this.MaritalStatus = maritalStatuslst[0].attributeName;
          } if (this.lstLanguage.length > 0) {
            var languagelst = this.lstLanguage.filter(x => x.attributeId === this.lstPatientRequestInformation.Languages.toString())
            if (languagelst.length > 0)
              this.Language = languagelst[0].attributeName;
          }
          if (this.lstGender.length > 0) {
            var genderlst = this.lstGender.filter(x => x.attributeId === this.lstPatientRequestInformation.Gender.toString())
            if (genderlst.length > 0)
              this.Gender = genderlst[0].attributeName;
          }
          if (this.lstLocations.length > 0) {
            var locationlst = this.lstLocations.filter(x => x.locationId === Number(this.lstPatientRequestInformation.Locations))
            if (locationlst.length > 0)
              this.Locations = locationlst[0].locationName;
          } if (this.lstPreferredContactMethod.length > 0) {
            var preferredContMethlst = this.lstPreferredContactMethod.filter(x => x.attributeId === this.lstPatientRequestInformation.PreferredContactMethod.toString())
            if (preferredContMethlst.length > 0)
              this.PreferredContactMethod = preferredContMethlst[0].attributeName;
          }
          if (this.lstcontacttype.length > 0) {
            var contactTypelst = this.lstcontacttype.filter(x => x.attributeId === this.contactType)
            if (contactTypelst.length > 0)
              this.EmergencyContactType = contactTypelst[0].attributeName;
          }
          if (this.lstrelations.length > 0) {
            var relationlst = this.lstrelations.filter(x => x.attributeId.toString() === emergencyContactRelation.toString())
            if (relationlst.length > 0)
              this.EmergencyContactRelation = relationlst[0].attributeName;
          }
          this.spinner.hide();
        },

        (err: any) => {
          console.log(err);
          this.spinner.hide();
        });

  }

  onClick_navigateToDemographics() {
    sessionStorage.removeItem("AlertsheaderIconVisibility");
    this.router.navigate(['/Demographics/Personal', this.linkID, 'Portal']);
  }
  onClick_backToMessages() {
    // this.router.navigate(['messageInbox']);
    this.router.navigate(['tasksandmessages/', 'BackToMessages']);
  }
  rejectRequestInfo: MessageInbox;
  onClick_ReasonForReject() {
    this.rejectRequestInfo = this.PatientRequestInformationForm.value;
    this.rejectRequestInfo.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.rejectRequestInfo.comments = this.PatientRequestInformationForm.value.rejectNotes;
    this.rejectRequestInfo.linkId = this.linkID.toString();
    this.rejectRequestInfo.status = 'Rejected';
    this.rejectRequestInfo.requestType = '1';
    if (this.PatientRequestInformationForm.value.rejectNotes != '') {
      this.personalService.updatePatientRequestInformationByLinkId(this.rejectRequestInfo)
        .subscribe(
          (result: any) => {
            this.toastr.success(result)
            this.getPatientRequestDetails(this.linkID);
          },
          (err: any) => {
            console.log(err);
          });
    }


  }

  changeReasonforReject(event: any) {
    if (event.target.checked) {
      this.isVisableRejectreason = true;
      this.isDisableDemographicsbutton = true;

    }
    else {
      this.PatientRequestInformationForm.patchValue({
        rejectNotes: ''
      })
      this.isVisableRejectreason = false;
      this.isDisableDemographicsbutton = false;
    }
  }
}
